import styled, { css } from 'styled-components';
/**
 * Use this in conjuction with Overlay.
 */
export const OverlayContainer = styled.div<{ $display?: React.CSSProperties['display'] }>`
  position: relative;
  display: ${props => props.$display || 'inline-block'};
`;

const centerContent = css`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
`;

/**
 * All the children elements of this container will be
 * overlayed over its siblings nodes. Must be the last item of the
 * `OverlayContainer` to enable events on the overlay.
 * ### Example
 * ```tsx
 * const App = () => <OverlayContainer>
 *  <h1>My Title</h1>
 *  <p>Some Text</p>
 *  <Overlay $center>Hover over to see that I am overlayed!</Overlay>
 * </OverlayContainer>
 * ```
 */
export const Overlay = styled.div<{ $center?: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  opacity: 0;
  transition: 0.2s ease;

  ${props => props.$center && centerContent}

  &:hover {
    opacity: 1;
  }
`;
